module.exports = __webpack_public_path__ + "img/107026.3f032f16.png";